import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Landing from "./pages/Landing";
import Documnetation from "./components/Documentation/Documentation";
import './App.css';

function App() {
  return (
    <Router>
      <main className="app-content">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/docs" element={<Documnetation />} />
        </Routes>
      </main>
    </Router>
  );
}

export default App;
